import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const FriendsNotification = ({ show, onDismiss, message }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/friends');
    onDismiss(); // Dismiss the notification when navigating
  };

  if (!show) return null;

  return (
    <Alert 
      variant="info" 
      className="friends-notification"
      style={{
        position: 'fixed',
        top: '80px', // Position below availability notification
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1049, // Slightly lower z-index than availability notification
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        border: 'none',
        borderRadius: '8px'
      }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="flex-grow-1">
          <Alert.Heading className="mb-1" style={{ fontSize: '1rem' }}>
            <i className="fas fa-users me-2"></i>
            No Friends Yet
          </Alert.Heading>
          <p className="mb-0" style={{ fontSize: '0.9rem' }}>
            {message}
          </p>
        </div>
        <div className="ms-3">
          <Button 
            variant="outline-info" 
            size="sm"
            onClick={handleClick}
            style={{ 
              borderColor: '#0dcaf0',
              color: '#055160',
              fontWeight: 'bold'
            }}
          >
            Add Friends
          </Button>
          <Button 
            variant="link" 
            size="sm"
            onClick={onDismiss}
            style={{ 
              color: '#055160',
              textDecoration: 'none',
              padding: '0.25rem 0.5rem'
            }}
          >
            <i className="fas fa-times"></i>
          </Button>
        </div>
      </div>
    </Alert>
  );
};

export default FriendsNotification;
